import * as React from "react";
import { IconBase, IIconBase } from "./IconBase";

export const PowerPlantIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props}>
    <title>powerplant</title>
    <path d="M26,24V6H6V42H42V24ZM14,29l1-9H10L19,8,18,18h5ZM31,39H27V35h4Zm0-8H27V27h4Zm8,8H35V35h4Zm0-8H35V27h4Z" />
  </IconBase>
);
